<section class="page-shell">
  <header class="page-hero dbw-card dbw-card--xl">
    <div>
      <p class="eyebrow">Reporting</p>
      <h3>Métadatas à corriger ou à analyser</h3>
    </div>

    <div class="hero-actions">
      <oui-button
        iconSuffix="download"
        (click)="exportCsv()"
        [disabled]="exporting()">
        Export CSV
      </oui-button>
      <oui-button
        color="secondary"
        type="outlined"
        iconSuffix="sync"
        (click)="reload()"
        [disabled]="loading()">
        Recharger
      </oui-button>
      <oui-button
        color="secondary"
        type="outlined"
        iconSuffix="arrow_forward"
        (click)="openBatch()">
        Ouvrir le batch
      </oui-button>
    </div>
  </header>

  @if (report(); as vm) {
    <dbw-summary-grid [items]="summaryItems()"></dbw-summary-grid>
  }

  @if (loading()) {
    <dbw-state-card appearance="loading">
      <p>Chargement du reporting en cours.</p>
    </dbw-state-card>
  }

  @if (error() && !loading()) {
    <dbw-state-card
      appearance="error"
      title="Chargement impossible">
      <p>{{ error() }}</p>
    </dbw-state-card>
  }

  @if (report(); as vm) {
    <section class="content-grid">
      <article class="panel searchbar-panel dbw-card dbw-card--xl">
        <div class="panel-heading">
          <h4>Filtres</h4>
        </div>
        <div class="filter-controls">
          <oui-searchbar
            type="filter"
            placeholder="Filtrer le reporting sur tous les champs"
            [value]="metadataFilter()"
            (valueChange)="metadataFilter.set($event ? $event.toString() : '')">
          </oui-searchbar>
          <oui-select-filter
            label="Types de problèmes"
            type="list"
            listPlaceholder="Rechercher un type"
            [listOptions]="problemTypeOptions()"
            [value]="selectedProblemKinds()"
            (valueChange)="selectedProblemKinds.set($event ?? [])">
          </oui-select-filter>
        </div>
      </article>
      <article class="panel dbw-card dbw-card--xl">
        <div class="panel-heading">
          <div>
            <h4>Corrections candidates</h4>
            <p>{{ groupedCorrections().length }} métadata(s) affichée(s)</p>
          </div>
          <oui-tag
            type="status"
            status="to-correct"
            >{{ vm.correctionMetadataCount }} métadata(s)</oui-tag
          >
        </div>
        <div class="group-list">
          @for (group of groupedCorrections(); track group.metadataId) {
            <article class="metadata-group dbw-card dbw-card--lg">
              <header class="metadata-group__header">
                <div>
                  <h5>Metadata {{ group.metadataId }}</h5>
                  <p>
                    {{ group.investorCount }} investisseur(s) distinct(s) • {{ group.avancementCount }} avancement(s) •
                    {{ group.consultantNames.join(', ') || 'Consultant non renseigné' }}
                  </p>
                </div>
                <oui-button
                  type="outlined"
                  (click)="openMetadata(group.metadataId)">
                  Traiter la metadata
                </oui-button>
              </header>
              <oui-table
                class="data-table"
                [lineSizing]="'dense'">
                <table
                  mat-table
                  [dataSource]="group.rows">
                  <ng-container matColumnDef="investor">
                    <th
                      mat-header-cell
                      *matHeaderCellDef>
                      Investisseur
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row">
                      <div class="content-long">
                        <dbw-investor-card
                          [id]="row.investorId"
                          [code]="row.investorCode || 'Code inconnu'"
                          [name]="row.displayName || 'Investisseur sans nom'"
                          [statusCode]="row.statusCode"></dbw-investor-card>
                        @if (row.atlasPersonnePhysiqueIds.length > 1) {
                          <div>
                            Personnes physiques Atlas:
                            {{ row.atlasPersonnePhysiqueIds.join(', ') }}
                          </div>
                        }
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="consultant">
                    <th
                      mat-header-cell
                      *matHeaderCellDef>
                      Consultant
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row">
                      <dbw-consultant-card
                        [id]="row.consultantId"
                        [code]="row.consultantCode || '-'"
                        [name]="row.consultantName || '-'"
                        [statusCode]="row.consultantStatusCode"></dbw-consultant-card>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="detection">
                    <th
                      mat-header-cell
                      *matHeaderCellDef>
                      Détection
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row">
                      <oui-tag
                        type="status"
                        [status]="getDetectionTagStatus('correction')">
                        {{ row.detectionLabel || 'Doublon investisseur' }}
                      </oui-tag>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="details">
                    <th
                      mat-header-cell
                      *matHeaderCellDef>
                      Détails
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row">
                      <div class="content-short">
                        <dbw-investor-status-tag [statusCode]="row.statusCode"></dbw-investor-status-tag>
                        <div>
                          ArianeId: {{ row.arianeId ?? '-' }} • AvancementId:
                          {{ row.avancementId }}
                        </div>
                        @if (row.atlasPersonnePhysiqueIds.length > 1) {
                          <div>
                            Personnes physiques Atlas:
                            {{ row.atlasPersonnePhysiqueIds.join(', ') }}
                          </div>
                        }
                      </div>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="groupedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: groupedColumns"></tr>
                </table>
              </oui-table>
            </article>
          }
        </div>
      </article>
      <article class="panel dbw-card dbw-card--xl">
        <div class="panel-heading">
          <div>
            <h4>Anomalies</h4>
            <p>{{ groupedAnomalies().length }} métadata(s) affichée(s)</p>
          </div>
          <oui-tag
            type="status"
            status="error"
            >{{ vm.anomalyMetadataCount }} métadata(s)</oui-tag
          >
        </div>
        <div class="group-list">
          @for (group of groupedAnomalies(); track group.metadataId) {
            <article class="metadata-group anomaly dbw-card dbw-card--lg">
              <header class="metadata-group__header">
                <div>
                  <h3>Metadata {{ group.metadataId }}</h3>
                  <p>
                    {{ group.investorCount }} investisseur(s) distinct(s) • {{ group.avancementCount }} avancement(s) •
                    {{ group.consultantNames.join(', ') || 'Consultant non renseigné' }}
                  </p>
                </div>
                <oui-button
                  type="outlined"
                  color="secondary"
                  (click)="openMetadata(group.metadataId)">
                  Inspecter
                </oui-button>
              </header>
              <oui-table
                class="data-table"
                [lineSizing]="'dense'">
                <table
                  mat-table
                  [dataSource]="group.rows">
                  <ng-container matColumnDef="investor">
                    <th
                      mat-header-cell
                      *matHeaderCellDef>
                      Investisseur
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row">
                      <div class="content-long">
                        <dbw-investor-card
                          [id]="row.investorId"
                          [code]="row.investorCode || 'Code inconnu'"
                          [name]="row.displayName || 'Investisseur sans nom'"
                          [statusCode]="row.statusCode"></dbw-investor-card>
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="consultant">
                    <th
                      mat-header-cell
                      *matHeaderCellDef>
                      Consultant
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row">
                      <dbw-consultant-card
                        [id]="row.consultantId"
                        [code]="row.consultantCode || '-'"
                        [name]="row.consultantName || '-'"
                        [statusCode]="row.consultantStatusCode"></dbw-consultant-card>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="detection">
                    <th
                      mat-header-cell
                      *matHeaderCellDef>
                      Détection
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row">
                      <oui-tag
                        type="status"
                        [status]="getDetectionTagStatus('anomaly')">
                        {{ row.detectionLabel || 'Anomalie' }}
                      </oui-tag>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="details">
                    <th
                      mat-header-cell
                      *matHeaderCellDef>
                      Détails
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row">
                      <div>
                        <dbw-investor-status-tag [statusCode]="row.statusCode"></dbw-investor-status-tag>
                        <div>
                          AvancementId: {{ row.avancementId }} • Nb:
                          {{ row.avancementCount }}
                        </div>
                        @if (row.arianeId) {
                          <div>Ariane {{ row.arianeId }}</div>
                        }
                        @if (row.atlasPersonnePhysiqueIds.length > 1) {
                          <div>
                            Personnes physiques Atlas:
                            {{ row.atlasPersonnePhysiqueIds.join(', ') }}
                          </div>
                        }
                      </div>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="groupedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: groupedColumns"></tr>
                </table>
              </oui-table>
            </article>
          }
        </div>
      </article>
    </section>
  }
</section>
